$(function () {
    var colTitles = idesConfig.getColText;
    var colTitlesArr = colTitles.split(',');
    var parsedTitles = {};
    for (var i = 0, j = colTitlesArr.length; i < j; i++) {
        var colTitleVal = colTitlesArr[i].trim();
        parsedTitles[colTitleVal] = (parsedTitles[colTitleVal] || 0) + 1;
    }
    var hasColSpan = new Array();
    $('#listTable th').each(function () {
        var th = this;
        var hdrVal = this.innerText.trim();
        if (hasColSpan.indexOf(hdrVal) > -1) {
            $(this).remove();
        } else {
            $(this).attr('colSpan', parsedTitles[hdrVal]);
        }
        hasColSpan.push(hdrVal);
    });
});